export class ValueWithBackup {
    constructor() {
        this.value = undefined;
        this.backupValue = undefined;
    }
    get() {
        return this.value;
    }
    getOrBackup() {
        var _a;
        return (_a = this.value) !== null && _a !== void 0 ? _a : this.backupValue;
    }
    setAndBackup(value) {
        this.value = value;
        this.backupValue = value;
    }
    remove() {
        this.value = undefined;
    }
    clean() {
        this.value = undefined;
        this.backupValue = undefined;
    }
    hasValue() {
        return this.value !== undefined;
    }
}
